import { DESTROY_SESSION } from './actionTypes';
import { getAllState } from './messages/messageAction';

export const clearReducers = () => {
    return (dispatch, getState) => {
        const { abare, socket } = getAllState(getState())
        socket.emit('leave', abare?.id)
        dispatch({ type: DESTROY_SESSION })
    }
};